import React from 'react'
import { AppBar, Container, Toolbar, styled } from '@mui/material'

const StyledAppBar = styled(AppBar)(({ theme, bgColor }) => ({
    backgroundColor: bgColor,
}))

const StyledContainer = styled(Container)({
    padding: 0,
    display: 'flex', // for IE
    flexDirection: 'column',
})

const StyledToolbar = styled(Toolbar)(({ theme, height }) => ({
    //alignItems: 'stretch',
    width: '100%',
    flexDirection: 'column',
    padding: '0.8rem 1.4rem',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    minHeight: height,
}))

const MobileHeader = ({ children, bgColor, height }) => {
    return (
        <StyledAppBar bgColor={bgColor}>
            <StyledContainer maxWidth="xl">
                <StyledToolbar disableGutters height={height}>
                    {children}
                </StyledToolbar>
            </StyledContainer>
        </StyledAppBar>
    )
}

MobileHeader.defaultProps = {
    bgColor: '#fff',
}

export default MobileHeader
